// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieAgree_root__q_28U","content":"CookieAgree_content__3nLdX","policy":"CookieAgree_policy__1cdW4","agree":"CookieAgree_agree__125q6"};